import './google-address.scss';

import * as gzGoogleAddressDirective from './google-address.directive';
import * as gzSelectAddress from './select-address-dialog.controller';
import gazelleCore from 'gazelle/src/core/core.module';

export default angular.module('gazelle.components.googleAddress', [
  'rhino.core.http',
  'rhino.components.locale',
  'gazelle.components.googleMaps',
  'gazelle.components.time',
  'pascalprecht.translate',
  'ngMaterial',
  gazelleCore,
])
  .directive(gzGoogleAddressDirective.name, gzGoogleAddressDirective.default)
  .controller(gzSelectAddress.name, gzSelectAddress.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/google-address/google-address.module.js